import type { InstagramFeedData } from '@/types/instagramFeed';
import { OFFICIAL_INSTAGRAM_URL } from '@/config/siteOrganization';

const EMPTY_FEED: InstagramFeedData = {
  configured: false,
  updatedAt: null,
  profileUrl: OFFICIAL_INSTAGRAM_URL,
  items: [],
};

export async function fetchInstagramFeed(): Promise<InstagramFeedData> {
  const sources = [
    '/.netlify/functions/instagram-feed',
    '/instagram-feed.json',
  ];

  for (const source of sources) {
    try {
      const res = await fetch(source, { headers: { Accept: 'application/json' } });
      if (!res.ok) continue;
      const data = (await res.json()) as InstagramFeedData;
      if (data && Array.isArray(data.items)) {
        return {
          ...EMPTY_FEED,
          ...data,
          profileUrl: data.profileUrl || OFFICIAL_INSTAGRAM_URL,
        };
      }
    } catch {
      /* 次のソースを試す */
    }
  }

  return EMPTY_FEED;
}
